// extracted by mini-css-extract-plugin
export default {"AlertWrapper":"Alert_AlertWrapper__lA8t5","Alert":"Alert_Alert__yIgdo"};